export const STATES = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];
export const userAgent = 'Pocket Geek Home';
export const dashboardRoute = 'dashboard';
export const dashboardRouteWithSlash = `/${dashboardRoute}`;
export const myAccountRoute = 'account';
export const myAccountRouteWithSlash = `/${myAccountRoute}`;
export const myTechServicesRoute = 'tech-services';
export const myTechServicesRouteWithSlash = `/${myTechServicesRoute}`;
export const tutorialtechservices = '/tutorial/tech-services';
export const tutorialhomedevices = '/tutorial/home-devices';
export const tutorialaccount = '/tutorial/account';
export const tutorialmobile = '/tutorial/mobile';
export const familyManagementRoute = `/${myAccountRoute}/family-management`;
export const familyManagementRouteWithSlash = `/${familyManagementRoute}`;
export const signUpRoute = '/signup';
export const loginRouteWithSlash = '/login';
export const underMaintenanceRoute = '/under-maintenance';
export const logoutRouteWithSlash = '/logout';
